import React, { useEffect } from 'react';
import './App.css';
import { ContainerStyled } from './styles/globalStyles';
import { Layout } from './shared/components/layout';
import { Fluids } from './features/estimatingRequirements/fluids';
import { PaediatricProtein } from './features/estimatingRequirements/paediatricProtein';
import { PaediatricEnergy } from './features/estimatingRequirements/paediatricEnergy';
import { HomeScreen } from './features/homescreen';
import { PatientInformation } from './features/patientInformation';
import { ESLandingScreen } from './features/estimatingRequirements/esLandingScreen';
import { NextSteps } from './features/nextSteps';
import { HenryOxford } from './features/estimatingRequirements/henryOxford';
import { HarrisBenedict } from './features/estimatingRequirements/harrisBenedict';
import { MifflinStJeor } from './features/estimatingRequirements/mifflinStJeor';
import { Peng2018 } from './features/estimatingRequirements/peng2018';
import { AlternativeMeasures } from './features/alternativeMeasures';
import { Glim } from './features/malnutritionScreening/glim';
import { SimpleCaloricEquation } from './features/estimatingRequirements/simpleCaloricEquation';
import { FaisyEquation } from './features/estimatingRequirements/faisyEquation';
import { PennState } from './features/estimatingRequirements/pennState';
import { ModifiedPennState } from './features/estimatingRequirements/modifiedPennState';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { BoxRowStyled } from './features/homescreen/style';
import { DesktopSidePanel } from './shared/components/desktopSidePanel';
import '../src/styles/global.css';
import { MalnutritionScreening } from './features/malnutritionScreening';
import { Mst } from './features/malnutritionScreening/mst';
import { Must } from './features/malnutritionScreening/must';
import { ScreeningResults as MustScreeningResults } from './features/malnutritionScreening/must/screeningResults';
import { Summary } from './features/summary';
import { Contact } from './features/contact';
import { TermsAndConditions } from './features/termsAndConditions';
import { MSTScreeningResult } from './features/malnutritionScreening/mst/screeningResults';
import { MuscleScreening } from './features/muscleScreening';
import { HandGripStrength } from './features/muscleScreening/handGripStrength';
import { HGSScreeningResult } from './features/muscleScreening/handGripStrength/screeningResults';
import { CalfCircumference } from './features/muscleScreening/calfCircumference';
import { CalfCircumScreeningResult } from './features/muscleScreening/calfCircumference/screeningResults';
import { PalScreen } from './features/estimatingRequirements/peng2018/palScreen';
import { Sarcf } from './features/muscleScreening/sarcf';
import { ScreeningResults as SarcfScreeningResults } from './features/muscleScreening/sarcf/screeningResults';
import { Protein } from './features/estimatingRequirements/protein';
import { PaedFluid } from './features/estimatingRequirements/paedFluid';
import { Compare } from './features/compare';
import { InputScreen as CompareInputScreen } from './features/compare/inputScreen';
import { TableView as CompareTableView } from './features/compare/tableView';
import { Rni } from './features/rni';
import { InputScreen as RniInputScreen } from './features/rni/inputScreen';
import { TableView as RniTableView } from './features/rni/tableView';

const getScriptUrl = () => {
  const currentHostName = window.location.hostname.toLowerCase();
  return currentHostName.includes('www')
    ? 'https://assets.adobedtm.com/1a1f0c5245aa/46b904e59da8/launch-23df634c8c7a.min.js'
    : 'https://assets.adobedtm.com/1a1f0c5245aa/46b904e59da8/launch-dc7912689eae-development.min.js';
};

function App() {
  useEffect(() => {
    const renderScript = document.createElement(`script`);
    renderScript.src = getScriptUrl();
    renderScript.async = true;
    document.head.appendChild(renderScript);

    return () => {
      document.head.removeChild(renderScript);
    };
  }, []);
  return (
    <BrowserRouter>
      <Layout>
        <BoxRowStyled sx={{ alignItems: 'flex-start' }}>
          <Routes>
            <Route index element={<HomeScreen />} />
            <Route
              path="/patientInformation"
              element={
                <ContainerStyled fixed>
                  <PatientInformation />
                </ContainerStyled>
              }
            />

            <Route
              path="/estimating-requirements/protein"
              element={
                <ContainerStyled fixed>
                  <Protein />
                </ContainerStyled>
              }
            />

            <Route
              path="/estimating-requirements/fluids"
              element={
                <ContainerStyled fixed>
                  <Fluids />
                </ContainerStyled>
              }
            />
            <Route
              path="/estimating-requirements/paediatric-protein"
              element={
                <ContainerStyled fixed>
                  <PaediatricProtein />
                </ContainerStyled>
              }
            />
            <Route
              path="/estimating-requirements/paediatric-energy"
              element={
                <ContainerStyled fixed>
                  <PaediatricEnergy />
                </ContainerStyled>
              }
            />
            <Route
              path="/estimating-requirements/paediatric-fluid"
              element={
                <ContainerStyled fixed>
                  <PaedFluid />
                </ContainerStyled>
              }
            />

            <Route
              path="/estimating-requirements"
              element={
                <ContainerStyled fixed>
                  <ESLandingScreen />
                </ContainerStyled>
              }
            />
            <Route
              path="/estimating-requirements/henryOxford/*"
              element={
                <ContainerStyled fixed>
                  <HenryOxford />
                </ContainerStyled>
              }
            />
            <Route
              path="/estimating-requirements/harrisBenedict/*"
              element={
                <ContainerStyled fixed>
                  <HarrisBenedict />
                </ContainerStyled>
              }
            />
            <Route
              path="/estimating-requirements/mifflinStJeor/*"
              element={
                <ContainerStyled fixed>
                  <MifflinStJeor />
                </ContainerStyled>
              }
            />
            <Route
              path="peng2018/*"
              element={
                <ContainerStyled fixed>
                  <Peng2018 />
                </ContainerStyled>
              }
            />
            <Route
              path="peng2018/pal"
              element={
                <ContainerStyled fixed>
                  <PalScreen />
                </ContainerStyled>
              }
            />
            <Route
              path="/alternative-measures"
              element={
                <ContainerStyled fixed>
                  <AlternativeMeasures />
                </ContainerStyled>
              }
            />
            <Route
              path="/muscle-screening"
              element={
                <ContainerStyled fixed>
                  <MuscleScreening />
                </ContainerStyled>
              }
            />
            <Route
              path="/muscle-screening/sarc-f"
              element={
                <ContainerStyled fixed>
                  <Sarcf />
                </ContainerStyled>
              }
            />
            <Route
              path="/muscle-screening/sarc-f/screening-result"
              element={
                <ContainerStyled fixed>
                  <SarcfScreeningResults />
                </ContainerStyled>
              }
            />
            <Route
              path="/malnutrition-screening"
              element={
                <ContainerStyled fixed>
                  <MalnutritionScreening />
                </ContainerStyled>
              }
            />
            <Route
              path="/malnutrition-screening/must"
              element={
                <ContainerStyled fixed>
                  <Must />
                </ContainerStyled>
              }
            />
            <Route
              path="/malnutrition-screening/must/screening-result"
              element={
                <ContainerStyled fixed>
                  <MustScreeningResults />
                </ContainerStyled>
              }
            />
            <Route
              path="/malnutrition-screening/mst"
              element={
                <ContainerStyled fixed>
                  <Mst />
                </ContainerStyled>
              }
            />
            <Route
              path="/malnutrition-screening/mst/screening-result"
              element={
                <ContainerStyled fixed>
                  <MSTScreeningResult />
                </ContainerStyled>
              }
            />
            <Route
              path="/muscle-screening/handgrip-strength"
              element={
                <ContainerStyled fixed>
                  <HandGripStrength />
                </ContainerStyled>
              }
            />
            <Route
              path="/muscle-screening/handgrip-strength/screening-result"
              element={
                <ContainerStyled fixed>
                  <HGSScreeningResult />
                </ContainerStyled>
              }
            />
            <Route
              path="/muscle-screening/calf-circumference"
              element={
                <ContainerStyled fixed>
                  <CalfCircumference />
                </ContainerStyled>
              }
            />
            <Route
              path="/muscle-screening/calf-circumference/screening-result"
              element={
                <ContainerStyled fixed>
                  <CalfCircumScreeningResult />
                </ContainerStyled>
              }
            />
            <Route
              path="/malnutrition-screening/glim/*"
              element={
                <ContainerStyled fixed>
                  <Glim />
                </ContainerStyled>
              }
            />
            <Route
              path="/estimating-requirements/simpleCaloricEquation"
              element={
                <ContainerStyled fixed>
                  <SimpleCaloricEquation />
                </ContainerStyled>
              }
            />
            <Route
              path="/estimating-requirements/faisyEquation"
              element={
                <ContainerStyled fixed>
                  <FaisyEquation />
                </ContainerStyled>
              }
            />
            <Route
              path="/estimating-requirements/pennState"
              element={
                <ContainerStyled fixed>
                  <PennState />
                </ContainerStyled>
              }
            />

            <Route
              path="/summary"
              element={
                <ContainerStyled fixed>
                  <Summary />
                </ContainerStyled>
              }
            />

            <Route
              path="/estimating-requirements/modifiedPennState"
              element={
                <ContainerStyled fixed>
                  <ModifiedPennState />
                </ContainerStyled>
              }
            />
            <Route
              path="/nextSteps"
              element={
                <ContainerStyled fixed>
                  <NextSteps />
                </ContainerStyled>
              }
            />

            <Route
              path="/compare"
              element={
                <ContainerStyled fixed>
                  <Compare />
                </ContainerStyled>
              }
            />

            <Route
              path="/compare/inputs"
              element={
                <ContainerStyled fixed>
                  <CompareInputScreen />
                </ContainerStyled>
              }
            />

            <Route
              path="/compare/table"
              element={
                <ContainerStyled fixed>
                  <CompareTableView />
                </ContainerStyled>
              }
            />

            <Route
              path="/rni"
              element={
                <ContainerStyled fixed>
                  <Rni />
                </ContainerStyled>
              }
            />

            <Route
              path="/rni/inputs"
              element={
                <ContainerStyled fixed>
                  <RniInputScreen />
                </ContainerStyled>
              }
            />

            <Route
              path="/rni/table"
              element={
                <ContainerStyled fixed>
                  <RniTableView />
                </ContainerStyled>
              }
            />

            <Route
              path="/contact"
              element={
                <ContainerStyled fixed>
                  <Contact />
                </ContainerStyled>
              }
            />
            <Route
              path="/terms-and-conditions"
              element={
                <ContainerStyled fixed>
                  <TermsAndConditions />
                </ContainerStyled>
              }
            />
          </Routes>
          <DesktopSidePanel />
        </BoxRowStyled>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
